import { transformCurrencyAmountDto } from 'data/transformers/currency-amount';

const transformPushUpOrderItem = dto => ({
  itemId: dto.item_id,
  total: transformCurrencyAmountDto(dto.total),
  payable: transformCurrencyAmountDto(dto.payable),
  discount: transformCurrencyAmountDto(dto.discount),
  discounted: transformCurrencyAmountDto(dto.discounted)
});

const transformPushUpOption = _ref => {
  let {
    days,
    payable,
    description,
    price_per_day,
    discounted_price,
    default: isDefault,
    best_value,
    international,
    countries,
    total,
    discount,
    discounted,
    push_up_order_items
  } = _ref;
  return {
    days,
    isDefault,
    description,
    pricePerDay: transformCurrencyAmountDto(price_per_day),
    discountedPrice: discounted_price ? transformCurrencyAmountDto(discounted_price) : undefined,
    isBestValue: !!best_value,
    international,
    countries,
    payable: transformCurrencyAmountDto(payable),
    total: transformCurrencyAmountDto(total),
    discount: transformCurrencyAmountDto(discount),
    discounted: transformCurrencyAmountDto(discounted),
    pushUpOrderItems: push_up_order_items.map(transformPushUpOrderItem)
  };
};

export const transformPushUpOptions = dtos => dtos.map(transformPushUpOption);
export const transformPushUpMotivation = dto => ({
  title: dto.title,
  description: dto.description,
  highlight: dto.highlight
});
export const transformPushUpBulkDiscount = dto => ({
  itemCount: dto.item_count,
  discountPercent: dto.discount_percent
});
export const transformPushUpMinimumPrice = dto => ({
  total: transformCurrencyAmountDto(dto.total),
  payable: transformCurrencyAmountDto(dto.payable),
  discount: transformCurrencyAmountDto(dto.discount),
  hasFreeBump: dto.has_free_bump
});
export const transformPushUpsOptions = dto => ({
  freePushUpsCount: 0,
  freePushUpsExpireInDays: 0,
  hasPaymentsAccount: true,
  motivation: dto.motivation ? transformPushUpMotivation(dto.motivation) : undefined,
  options: dto.options ? transformPushUpOptions(dto.options) : []
});
export const transformPushUpOrderItems = function () {
  let dtos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return dtos.map(transformPushUpOrderItem);
};
export const transformPushUpOrder = dto => {
  var _dto$tax_coverage_ava, _dto$tax_covered;

  return {
    id: dto.id,
    status: dto.status,
    freeCount: dto.free_count,
    totalCount: dto.total_count,
    total: transformCurrencyAmountDto(dto.total),
    payIn: transformCurrencyAmountDto(dto.pay_in),
    payable: transformCurrencyAmountDto(dto.payable),
    discount: transformCurrencyAmountDto(dto.discount),
    discounted: transformCurrencyAmountDto(dto.discounted),
    freePushUpsValue: transformCurrencyAmountDto(dto.free_push_ups_value),
    discountPercentage: dto.discount_percentage,
    pushUpOrderItems: transformPushUpOrderItems(dto.push_up_order_items),
    salesTax: dto.sales_tax ? transformCurrencyAmountDto(dto.sales_tax) : null,
    isTaxCoverageAvailable: (_dto$tax_coverage_ava = dto.tax_coverage_available) !== null && _dto$tax_coverage_ava !== void 0 ? _dto$tax_coverage_ava : null,
    isTaxCovered: (_dto$tax_covered = dto.tax_covered) !== null && _dto$tax_covered !== void 0 ? _dto$tax_covered : null
  };
};